import MembershipDocumentListResourceModel from '../../generated/types/model/resource/MembershipDocumentListResourceModel';

export default class MembershipDocumentListResourceViewModel extends MembershipDocumentListResourceModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
